import React from 'react';
import NavBarButtons from "./NavBarButtons";
import {useForm} from "../../_hooks/useForm";
import {MembershipStepBox} from './style';
import {useSelector} from "react-redux";
import {AlertError} from "../Login/style";

const MembershipStep = (props) => {
    const {email} = useSelector(state => state.repository.user);
    const {msgError} = useSelector(state => state.ui);
    const [formValues, handleInputChange] = useForm({
        emailForm: email,
        contractFolio: '',
    });

    const { emailForm, contractFolio } = formValues;


    /*const handleCheckContract = (e) => {
        e.preventDefault();
        const userData = {}
        dispatch(getData(`/reefcontract/${userData}`, props)).then((response) => {
            if (response.status === 200) {}
        });
    }*/

    return (
        <>
            <MembershipStepBox>

                <div id="membership-reef-form">
                    <h2>Reef Membership</h2>

                    <div className="row">
                        <div className="col_full">
                            {
                                msgError &&
                                <AlertError>
                                    {msgError}
                                </AlertError>
                            }

                            <div className="col_half divcenter">
                                <label htmlFor="login-form-email">User Email:</label>
                                <input type="text"
                                       id="emailForm"
                                       name="emailForm"
                                       value={emailForm}
                                       onChange={handleInputChange}
                                       className="form-control not-dark"/>
                            </div>

                            <div className="col_half divcenter">
                                <label htmlFor="login-form-email">Contract Folio:</label>
                                <input type="text"
                                       id="contractFolio"
                                       name="contractFolio"
                                       value={contractFolio}
                                       onChange={handleInputChange}
                                       className="form-control not-dark"/>
                            </div>

                        </div>
                    </div>
                </div>

                <NavBarButtons data={formValues} previousStep={props.previousStep} nextStep={props.nextStep}
                               currentStep={props.currentStep}/>

            </MembershipStepBox>
        </>
    );
};

export default MembershipStep;
